<template>
  <div class="ui-confirm" role="alertdialog" :aria-label="title">
    <span>
      <b>{{ title }}</b>
      <slot></slot>
    </span>
    <span class="ui-actions"><slot name="actions"></slot></span>
  </div>
</template>

<script>
/** Potvrda unutar panela (umjesto prozora): naslov, objašnjenje (slot) i dugmad (slot actions). */
export default {
  name: "UiConfirm",
  props: { title: { type: String, required: true } },
};
</script>
